import React, { Component } from "react";
import { ConfiguracionAlcancesStore } from "../../../containers/comisionesMembresiaConfiguracion/configuracionAlcances/ConfiguracionAlcances.store";
import { ConfiguracionAlcancesDispatcher } from "../../../containers/comisionesMembresiaConfiguracion/configuracionAlcances/ConfiguracionAlcances.dispatcher";
import { Styled } from "../../../../toolkit/decorators/Artifact";
import s from "./styles.scss";
import ConfiguracionAlcancesTable from "./ConfiguracionAlcances.table";
import ComisionAlcance, {
  descTipoComision,
  TipoComision
} from "../../../../types/ComisionAlcance";
import {
  successNotification,
  errorNotification
} from "../../../../utils/notifications";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { formatGroupBy } from "../../../helpers/formatters";

interface Props
  extends ConfiguracionAlcancesStore,
    ConfiguracionAlcancesDispatcher {}

@Styled(s)
export default class ConfiguracionAlcancesComponent extends Component<Props> {
  componentDidMount() {
    this.loadAlcances();
  }

  loadAlcances = async () => {
    const preview = await this.props.getComisionAlcanceByTipos();

    if (preview.fulfilled) {
      successNotification("Alcances de comisión cargados correctamente");
    } else {
      errorNotification(preview.gettingComisionesAlcanceError);
    }
  };

  render() {
    const {
      comisionesAlcance: alcances,
      gettingComisionesAlcance: loading
    } = this.props;
    const grupos = alcances ? formatGroupBy(alcances, a => a.tipoComision) : {};
    const hasAlcances = alcances && alcances.length > 0;

    return (
      <div className="container">
        {loading && (
          <div className="row">
            <div className="col-md-12 text-center">
              <FontAwesomeIcon icon={faSpinner} pulse size="3x" />
              <p className="mt-3">Cargando alcances de comisión...</p>
            </div>
          </div>
        )}

        {!loading && !hasAlcances && (
          <div className="row">
            <div className="col-md-12 text-center">
              <p>No se encontraron alcances de comisión configurados.</p>
            </div>
          </div>
        )}

        {!loading && hasAlcances && (
          <div className="row">
            <div className="col-md-12">
              {/* Recorrido de los alcances por tipo de  */}
              {Object.keys(grupos).map((tipoKey, index) => (
                <div key={index} className={s.alcanceContent}>
                  <h5 className={s.alcanceTitle}>
                    {descTipoComision(tipoKey as TipoComision)}
                  </h5>

                  <ConfiguracionAlcancesTable alcances={grupos[tipoKey]} />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  }
}
